import "./todayWeather.css"
const TodayWeather =(props)=>{ 

    const t = props.t
    
    return(<div className="todayweatherContainer">
         <div className="todayweatherHeader">
         <h3>{t("Today's weather")}</h3>
         <h3>{props.weatherLocation.name}</h3>     
         <h2>  {props.weatherInThisTime[1].main.temp}°C</h2>
         <img alt="icone" src={`https://openweathermap.org/img/wn/${props.weatherInThisTime[1].weather[0].icon}@2x.png`}/>
         <p>{props.weatherInThisTime[1].weather[0].description}</p>
         </div>
    
    </div>)
}

export default TodayWeather;